import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Loader from '../../components/Loader/Loader';
import Swal from 'sweetalert2';
import moment from 'moment';

const Sale = () => {
  const { id } = useParams();
  const [loader, setLoader] = useState(false);

  const [isSlipModalOpen, setIsSlipModalOpen] = useState(false);

  const [courseDetails, setCourseDetails] = useState({});

  useEffect(() => {
    fetchCourseDetails(id);
  }, [id]);

  const fetchCourseDetails = (courseId) => {
    setLoader(true);
    const requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    fetch(`https://quran-backend-theta.vercel.app/v1/user/course/${courseId}`, requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result);
        // console.log("DATA", data?.course);

        setCourseDetails(data?.course);
        setLoader(false);
      })
      .catch((error) => console.error(error));
  };

  const handleDeleteClick = (note) => {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this note!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
        setLoader(true);

        const myHeaders = new Headers();
        myHeaders.append('Content-Type', 'application/json');
        myHeaders.append('Accept', 'application/json');
        myHeaders.append('Access-Control-Allow-Origin', '*');
        myHeaders.append('Authorization', `Bearer ${localStorage.getItem('token')}`);

        const requestOptions = {
          method: 'POST',
          headers: myHeaders,
          redirect: 'follow'
        };

        fetch(`https://quran-backend-theta.vercel.app/v1/admin/delete-sale/${id}`, requestOptions)
          .then((response) => response.text())
          .then((result) => {
            let data = JSON.parse(result);

            if (data.success === true) {
              Swal.fire({
                title: 'Deleted!',
                text: 'Your note has been deleted.',
                icon: 'success',
                confirmButtonText: 'OK'
              }).then(() => {
                fetchCourseDetails(id);
              });
            }

            if (data?.success === false) {
              if (data?.message === 'Expired') {
                localStorage.clear();
                window.location.reload();
                setLoader(false);
              } else {
                setLoader(false);
                toast.error(data?.message);
              }
            }
          })
          .catch((error) => {
            console.error(error);
            Swal.fire({
              title: 'Error!',
              text: 'An error occurred while deleting the note.',
              icon: 'error',
              confirmButtonText: 'OK'
            });
            setLoader(false);
          });
      }
    });
  };

  return (
    <section className="mb-20 mt-7">
      {loader === true ? (
        'Loading...'
      ) : (
        <div className="rounded-lg overflow-x-auto">
          {courseDetails?.salePrice ? (
            <div className="flex flex-col">
              <div className="sm:-mx-6 lg:-mx-8">
                <div className="inline-block min-w-full sm:px-6 lg:px-8">
                  <div className="overflow-hidden">
                    <table className="min-w-full mb-0">
                      <thead>
                        <tr className="rounded-lg whitespace-nowrap">
                          {/* <th className="text-sm text-primary font-bold px-6 py-4">Sr#</th> */}
                          <th className="text-sm text-primary font-bold px-6 py-4">Sale Name</th>
                          <th className="text-sm text-primary font-bold px-6 py-4">Sale Date</th>
                          <th className="text-sm text-primary font-bold px-6 py-4">Actual Price</th>
                          <th className="text-sm text-primary font-bold px-6 py-4">
                            Sale Discount
                          </th>
                          {/* <th className="text-sm text-primary font-bold px-6 py-4"> Discount</th> */}
                          <th className="text-sm text-primary font-bold px-6 py-4">Final Price</th>
                          {/* <th className="text-sm text-primary font-bold px-6 py-4">Action</th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {/* {notes?.map((student, index) => ( */}
                        <>
                          <tr
                            key={courseDetails?._id}
                            style={{
                              boxShadow: '0px 0px 63.44px 0px #00000012'
                            }}
                            className="bg-white border-b-8 border-white rounded-md"
                          >
                            <td className="align-middle bg-white text-sm font-normal px-6 py-3 whitespace-nowrap text-center">
                              <span className="bg-white text-base text-black py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline bg-green-200 rounded-full">
                                {courseDetails?.saleName}
                              </span>
                            </td>
                            <td className="align-middle bg-white text-sm font-normal px-6 py-3 whitespace-nowrap text-center">
                              <span className="bg-white text-base text-black py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline bg-green-200 rounded-full">
                                {moment(courseDetails?.saleValidDate).format('DD-MM-YYYY')}
                              </span>
                            </td>
                            <td className="align-middle bg-white text-sm font-normal px-6 py-3 whitespace-nowrap text-center">
                              <span className="bg-white text-base text-black py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline bg-green-200 rounded-full">
                                {courseDetails?.price}
                              </span>
                            </td>
                            {/* <td className="align-middle bg-white text-sm font-normal px-6 py-3 whitespace-nowrap text-center">
                             <span className="bg-white text-base text-black py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline bg-green-200 rounded-full">
                               ${courseDetails?.salePrice}
                             </span>
                           </td> */}
                            <td className="align-middle bg-white text-sm font-normal px-6 py-3 whitespace-nowrap text-center">
                              <span className="bg-white text-base text-black py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline bg-green-200 rounded-full">
                                {parseInt(courseDetails?.discountPercentage)}%
                              </span>
                            </td>

                            <td className="align-middle bg-white text-sm font-normal px-6 py-3 whitespace-nowrap text-center">
                              <span className="bg-white text-base text-black py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline bg-green-200 rounded-full">
                                {courseDetails?.finalPrice}
                              </span>
                            </td>

                            <td className="align-middle bg-white text-center text-sm font-normal px-6 py-4 whitespace-nowrap">
                              <div className=" flex justify-center items-center gap-3">
                                {/* <img
                                         src={require('../../assets/image/edit.png')}
                                         onClick={() => {
                                           setUpdateCources(true);
                                           setSingle(courseDetails);
                                         }}
                                         alt="Delete"
                                         style={{ cursor: 'pointer' }}
                                       /> */}
                                <img
                                  src={require('../../assets/image/del.png')}
                                  onClick={() => handleDeleteClick(courseDetails?._id)}
                                  alt="Delete"
                                  style={{ cursor: 'pointer' }}
                                />
                              </div>
                            </td>
                          </tr>
                        </>
                        {/* //   ))} */}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="text-center text-lg font-semibold text-gray-600 mt-10">
              No Data Available
            </div>
          )}
        </div>
      )}
    </section>
  );
};

export default Sale;
